import React, { useEffect, useRef } from "react";
import { MarkerClusterer } from "@googlemaps/markerclusterer";

function MapMarkers({ spots, mapInstance, setSelectedSpot }) {

  const markersRef = useRef([]);
  const clustererRef = useRef(null);

  useEffect(() => {
    if (!mapInstance || !window.google) return;

    // remove existing markers
    markersRef.current.forEach(marker => marker.map = null);
    markersRef.current = [];

    if (clustererRef.current) {
      clustererRef.current.clearMarkers();
    }

    const colors = {
      ledge: "#ff9f0a",
      rail: "#767373",
      stairs: "#ffd60a",
      gap: "#bf5af2",
      park: "#32d74b",
      curb: "#ff375f",
      ditch: "#64d2ff",
    };

    const markers = spots.map((spot) => {

      const pin = new window.google.maps.marker.PinElement({
        background: colors[spot.type] || "#ffffff",
        borderColor: "#111",
        glyphColor: "#111",
        scale: 1.35,
      });

      pin.element.style.filter =
        "drop-shadow(0 2px 4px rgba(0,0,0,0.5))";

     const marker = new window.google.maps.marker.AdvancedMarkerElement({
      position: { lat: spot.lat, lng: spot.lng },
      content: pin.element,
      zIndex: 2
    });

      marker.addListener("gmp-click", () => {
        setSelectedSpot(spot);
      });

      return marker;
    });

    markersRef.current = markers;

    // 🎨 Custom cluster renderer
    const renderer = {
      render: ({ count, position }) => {

        const div = document.createElement("div");

        div.style.background = "rgba(28,28,30,0.9)";
        div.style.border = "2px solid #ff453a";
        div.style.borderRadius = "999px";
        div.style.color = "white";
        div.style.fontWeight = "700";
        div.style.fontSize = "14px";
        div.style.padding = "10px 14px";
        div.style.backdropFilter = "blur(10px)";
        div.style.boxShadow = "0 4px 10px rgba(0,0,0,0.45)";
        div.style.display = "flex";
        div.style.alignItems = "center";
        div.style.justifyContent = "center";
        div.innerText = count;

        return new window.google.maps.marker.AdvancedMarkerElement({
          position,
          content: div,
        });
      }
    };

    clustererRef.current = new MarkerClusterer({
      map: mapInstance,
      markers,
      renderer,
    });

  }, [spots, mapInstance, setSelectedSpot]);

  return null;
}

export default React.memo(MapMarkers);